'use client';

import { createContext, useContext } from 'react';
import { Locale, Translations } from '.';
import deTranslations from './translations/de.json';
import enTranslations from './translations/en.json';

const translations = {
  de: deTranslations,
  en: enTranslations,
} as const;

const TranslationsContext = createContext<{
  translations: Translations;
  locale: Locale;
} | null>(null);

export function TranslationsProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return (
    <TranslationsContext.Provider value={{ translations: translations[locale], locale }}>
      {children}
    </TranslationsContext.Provider>
  );
}

export function useTranslations() {
  const context = useContext(TranslationsContext);
  if (!context) {
    throw new Error('useTranslations must be used within a TranslationsProvider');
  }

  const t = <T = string>(key: string): T => {
    const keys = key.split('.');
    let translation: any = context.translations;
    
    for (const k of keys) {
      translation = translation?.[k];
      if (!translation) return key as unknown as T;
    }
    
    return translation as T;
  };

  return {
    t,
    locale: context.locale,
  };
}
